export class RecorderAlreadyExistsError extends Error {
  constructor(err: Error) {
    super(err.message)
    Object.setPrototypeOf(this, RecorderAlreadyExistsError.prototype)
  }
}
